if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // FIX: Listen for variant changes to update the hidden input
        this.setupVariantChangeListener();
      }

      // FIX: New method to handle variant changes
      setupVariantChangeListener() {
        // Listen for variant changes from variant picker
        const variantSelects = document.querySelectorAll('variant-radios, variant-selects');
        
        variantSelects.forEach(variantPicker => {
          variantPicker.addEventListener('change', (event) => {
            // Get the selected variant ID from the event or from the fieldset
            const selectedVariantId = this.getSelectedVariantId();
            
            if (selectedVariantId && this.variantIdInput) {
              console.log('Updating variant ID to:', selectedVariantId);
              this.variantIdInput.value = selectedVariantId;
              this.variantIdInput.disabled = false;
            }
          });
        });

        // Also listen for direct changes to radio buttons and selects
        const allVariantInputs = this.form.querySelectorAll('input[name^="options"], select[name^="options"]');
        allVariantInputs.forEach(input => {
          input.addEventListener('change', () => {
            const selectedVariantId = this.getSelectedVariantId();
            if (selectedVariantId && this.variantIdInput) {
              console.log('Variant changed, updating ID to:', selectedVariantId);
              this.variantIdInput.value = selectedVariantId;
              this.variantIdInput.disabled = false;
            }
          });
        });
      }

      // FIX: Helper method to get the currently selected variant ID
      getSelectedVariantId() {
        // Try to get it from the URL parameters (Shopify updates this)
        const urlParams = new URLSearchParams(window.location.search);
        const variantParam = urlParams.get('variant');
        
        if (variantParam) {
          return variantParam;
        }

        // If not in URL, try to get from variant picker
        const variantRadios = document.querySelector('variant-radios');
        const variantSelects = document.querySelector('variant-selects');
        
        if (variantRadios) {
          const selectedInput = variantRadios.querySelector('input:checked');
          if (selectedInput) {
            return selectedInput.value;
          }
        }
        
        if (variantSelects) {
          const selectedOption = variantSelects.querySelector('select option:checked');
          if (selectedOption) {
            return selectedOption.value;
          }
        }

        // Fallback to current input value
        return this.variantIdInput?.value;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // FIX: Double-check variant ID before submitting
        const currentVariantId = this.variantIdInput.value;
        console.log('Submitting with variant ID:', currentVariantId);
        
        if (!currentVariantId || currentVariantId === 'null' || currentVariantId === '') {
          console.error('Invalid variant ID:', currentVariantId);
          this.handleErrorMessage('Please select a valid product variant');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // FIX: Explicitly ensure the correct variant ID is being sent
        formData.set('id', currentVariantId);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}